import api from '../../services/api';

const state = {
  user: null,
  token: localStorage.getItem('token'),
  apiKey: localStorage.getItem('apiKey')
};

const getters = {
  isAuthenticated: state => !!state.token,
  currentUser: state => state.user,
  isAdmin: state => state.user?.role === 'admin',
  apiKey: state => state.apiKey
};

const actions = {
  async login({ commit }, credentials) {
    try {
      console.log('Attempting login with:', credentials);
      const response = await api.post('/auth/login', credentials);
      console.log('Login response:', response.data);
      const { token, user, api_key } = response.data;
      
      localStorage.setItem('token', token);
      localStorage.setItem('apiKey', api_key);
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      api.defaults.headers.common['X-API-Key'] = api_key;
      
      commit('SET_AUTH', { token, user, apiKey: api_key });
      return { success: true };
    } catch (error) {
      console.error('Login error:', error);
      console.error('Error response:', error.response);
      return { 
        success: false, 
        error: error.response?.data?.error || 'Login failed' 
      };
    }
  },
  
  async register({ commit }, userData) {
    try {
      const response = await api.post('/auth/register', userData);
      const { token, user, api_key } = response.data;
      
      localStorage.setItem('token', token);
      localStorage.setItem('apiKey', api_key);
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      api.defaults.headers.common['X-API-Key'] = api_key;
      
      commit('SET_AUTH', { token, user, apiKey: api_key });
      return { success: true };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.error || 'Registration failed' 
      };
    }
  },
  
  logout({ commit, dispatch }) {
    localStorage.removeItem('token');
    localStorage.removeItem('apiKey');
    delete api.defaults.headers.common['Authorization'];
    delete api.defaults.headers.common['X-API-Key'];
    commit('CLEAR_AUTH');
    // Clear products to prevent showing stale data
    dispatch('products/clearProducts', null, { root: true });
  },
  
  async initAuth({ commit }) {
    const token = localStorage.getItem('token');
    const apiKey = localStorage.getItem('apiKey');
    if (token && apiKey) {
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      api.defaults.headers.common['X-API-Key'] = apiKey;
      commit('SET_TOKEN', token);
      commit('SET_API_KEY', apiKey);
      
      // Fetch current user data
      try {
        const response = await api.get('/users/me');
        commit('SET_AUTH', { token, user: response.data, apiKey });
      } catch (error) {
        // If fetching user fails, clear auth
        localStorage.removeItem('token');
        localStorage.removeItem('apiKey');
        delete api.defaults.headers.common['Authorization'];
        delete api.defaults.headers.common['X-API-Key'];
        commit('CLEAR_AUTH');
      }
    }
  }
};

const mutations = {
  SET_AUTH(state, { token, user, apiKey }) {
    state.token = token;
    state.user = user;
    state.apiKey = apiKey;
  },
  SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_API_KEY(state, apiKey) {
    state.apiKey = apiKey;
  },
  CLEAR_AUTH(state) {
    state.token = null;
    state.user = null;
    state.apiKey = null;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};